module.exports = __webpack_public_path__ + "assets/img/banner-footer-1920.jpg";